<template>
  <v-card class="text-ad">
    <v-list class="py-0">
      <v-list-tile>
        <v-list-tile-action class="caption font-weight-bold pr-0 mr-0 ad-text-block">
          <span>{{ $t('message.ad') }} <small>{{ `\u00b7 ` }}</small></span>
        </v-list-tile-action>

        <v-list-tile-content class="ml-0 pl-0">
          <v-list-tile-title class="caption">
            {{ websiteUrl }}
          </v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-icon small color="grey lighten-2" class="font-xs">
            info
          </v-icon>
        </v-list-tile-action>
      </v-list-tile>

      <v-list-tile class="headline">
        <v-list-tile-content>
          <v-list-tile-title class="blue--text headline-text">
            {{ toCustomTitleCase(textAd.headline1) }} | {{ toCustomTitleCase(textAd.headline2) }} | {{ textAd.businessName }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-list
      class="my-2"
    >
      <v-list-tile>
        <v-list-tile-content>
          <span class="body-1 description-text-block">{{ toCustomTitleCase(ad.description) }}. {{ toCustomTitleCase(textAd.description2) }}</span>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider class="mx-3" />
    <v-list class="my-2">
      <v-list-tile>
        <v-list-tile-avatar icon>
          <v-icon>assignment</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content class="ml-0">
          <v-list-tile-title class="headline-text body-2">
            {{ $t('message.bizgainOnboarding.leadsGetOffer') }}
          </v-list-tile-title>
          <v-list-tile-sub-title class="caption">
            {{ $t('message.bizgainOnboarding.leadsOfferSubmitText') }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>
<script>
import {
  VIcon,
  VCard,
  VList,
  VListTile,
  VListTileTitle,
  VListTileSubTitle,
  VListTileAvatar,
  VListTileAction,
  VListTileContent,
  VDivider
} from 'vuetify/lib';
import { toCustomTitleCase } from 'Features/bizgainOnboarding/helpers/textCaseConvertHelper';
export default {
  components: {
    VIcon,
    VCard,
    VList,
    VListTile,
    VListTileTitle,
    VListTileSubTitle,
    VListTileAvatar,
    VListTileAction,
    VListTileContent,
    VDivider
  },
  props: {
    ad: {
      type: Object,
      default: null
    },
    textAd: {
      type: Object,
      default: null
    },
    mobileNumber: {
      type: String,
      default: '+918040901437'
    },
    websiteUrl: {
      type: String,
      default: null
    }
  },
  methods: {
    toCustomTitleCase
  }
}
</script>
<style lang="scss" scoped>
.text-ad{
   border-radius:5px;
}
.ad-text-block{
   min-width:25px !important;
}

.description-text-block{
   min-height:45px;
   max-height:45px;
   display: -webkit-box;
   -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
   overflow: hidden;
   text-overflow: ellipsis;
   text-align: start;
   word-break: break-word;
}

::v-deep .headline .v-list__tile{
  height:fit-content;
}

.headline-text {
   white-space: unset;
   word-break: break-word;
   font-size: 18px;
   max-height: 48px;
   height: auto;
   min-height:fit-content;
}
</style>